import React, { useState } from 'react';
import {
  Grid,
  styled,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  TextField,
  Paper,
  Button,
  Typography
} from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import PageHeader from '../../../components/PageHeader';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../../../api';
import AreaZoneFromInput from '../../../components/formInput/AreaZoneFromInput';

const CreateArea: React.FC = () => {
  const navigate = useNavigate();

  const [name, setName] = useState<string>('');
  const [code, setCode] = useState<string>('');
  const [zoneId, setZoneId] = useState<number | null>(null);
  const [isRequireWPM, setIsRequireWPM] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleFormSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (isLoading) {
      return;
    }
    if (name) {
      setIsLoading(true);
      api
        .post('/area', {
          area_name: name,
          area_code: code,
          is_require_wpm: isRequireWPM,
          zone_id: zoneId
        })
        .then(() => {
          navigate('/area');
        })
        .finally(() => setIsLoading(false));
    }
  };

  return (
    <RootContainer>
      <PageHeader text="เพิ่มพื้นที่" />
      {/* <Container sx={{ mt: 3 }}> */}
      <Button component={Link} to="/area" sx={{ my: 3, p: 0 }}>
        <ArrowBackIosIcon />
        พื้นที่
      </Button>

      <Paper sx={{ p: 1 }}>
        <Typography variant="h6" sx={{ px: 2, pt: 2, pb: 1 }}>
          {'เพิ่มข้อมูล'}
        </Typography>

        <Form onSubmit={handleFormSubmit} sx={{ padding: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="รหัสพื้นที่"
                variant="outlined"
                placeholder="รหัสพื้นที่"
                onChange={(e) => setCode(e.target.value ? e.target.value : '')}
                value={code}
                required
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="ชื่อพื้นที่"
                variant="outlined"
                placeholder="ชื่อพื้นที่"
                onChange={(e) => setName(e.target.value ? e.target.value : '')}
                value={name}
                required
              />
            </Grid>
            <Grid item xs={6}>
              <AreaZoneFromInput value={zoneId} onChange={(value) => setZoneId(value)} required />
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel id="is_require_wpm">ต้องการ work permit</InputLabel>
                <Select
                  labelId="is_require_wpm"
                  label="ต้องการ work permit"
                  variant="outlined"
                  onChange={(e) => setIsRequireWPM(e.target.value == 'true')}
                  value={`${isRequireWPM}`}
                  autoComplete="off"
                >
                  <MenuItem value="true">ต้องการ</MenuItem>
                  <MenuItem value="false">ไม่ต้องการ</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container columns={2} spacing={2} direction={'row-reverse'}>
            <Grid item>
              <Button type="submit" variant="contained" color="primary" sx={{ marginTop: 4 }}>
                เพิ่มข้อมูล
              </Button>
            </Grid>
          </Grid>
        </Form>
      </Paper>
      {/* </Container> */}
    </RootContainer>
  );
};

export default CreateArea;

const RootContainer = styled('div')`
  padding: 24px;
`;

const Form = styled('form')`
  display: flex;
  flex-direction: column;
  align-items: end;
`;
